module.exports = __webpack_public_path__ + "img/bell-green-border.0d5d9ccc.svg";